import type {Logger} from './Logger';
import {Notyf} from 'notyf';

export class Notifier {
    private logger: Logger;
    private toaster: Notyf;

    constructor(logger: Logger) {
        this.logger = logger;
        this.toaster = new Notyf({position: {x: 'right', y: 'top'}});
    }

    success(message: string) {
        this.toaster.success(message);
    }

    errorMessage(message: string) {
        if ((message?.length ?? 0) === 0) {
            message = 'Oops... it looks like something went wrong. Please try again.';
        }
        this.toaster.error(message);
    }

    error(error: Error, message: string = '', context = {}) {
        this.errorMessage(message);
        if (error) {
            this.logger.error(error, context);
        }
    }
}
